import React, { useState, useEffect, useCallback } from 'react';
import { ethers } from 'ethers';
import { NFT_ADDRESS, NFT_ABI } from '../contracts/nftABI';
import '../styles/NFTMint.css';
import { FaSpinner, FaCrown, FaGem, FaMedal, FaCheckCircle, FaGift, FaLock, FaEthereum, FaUsers, FaRocket } from 'react-icons/fa';
import { SiFireship } from 'react-icons/si';
import Navbar from './Navbar';

const FIRM_TOKEN_ADDRESS = '0x2d3a62162fa581f4d972b31fcc28ac9b2df3191b';
const FIRM_TOKEN_ABI = [
  'function approve(address spender, uint256 amount) returns (bool)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function balanceOf(address account) view returns (uint256)',
  'function decimals() view returns (uint8)'
];

const NFT_TYPES = [
  {
    id: 0,
    name: "FIRM DIAMOND NFT",
    description: (
      <div className="benefits-list">
        <div className="benefits-item">
          <FaUsers className="benefit-icon" />
          <span>Exclusive Whales TG & Private Tools Access</span>
        </div>
        <div className="benefits-item">
          <FaGift className="benefit-icon" />
          <span>Premium 10-Week Airdrop: 500M PF Weekly</span>
        </div>
        <div className="benefits-item">
          <FaRocket className="benefit-icon" />
          <span>Priority Access to ECA & Future Projects</span>
        </div>
        <div className="benefits-item">
          <FaEthereum className="benefit-icon" />
          <span>0.1 ETH Worth of New Token Airdrops</span>
        </div>
        <div className="benefits-item">
          <FaLock className="benefit-icon" />
          <span>Full Exclusive Access to All Firm Tools</span>
        </div>
        <div className="benefits-item">
          <FaCheckCircle className="benefit-icon" />
          <span>Private Sale Access</span>
        </div>
        <div className="benefits-item">
          <FaEthereum className="benefit-icon" />
          <span>ETH Revenue Sharing Benefits</span>
        </div>
      </div>
    ),
    tokenId: 0,
    imageUrl: "https://nft-cdn.alchemy.com/eth-mainnet/0c7594c66bbaba4664234a70d7ca408c",
    videoUrl: "https://img.x2y2.io/ipfs/QmYjF8xSjB2vWuqkc6zZ4BbrY9n6b7rEkvdG12k6BnGZT2/0.mp4",
    tier: "Diamond",
    price: "10000000000", // 10 billion
    icon: <FaCrown className="tier-icon diamond" />
  },
  {
    id: 1,
    name: "FIRM GOLDEN NFT",
    description: (
      <div className="benefits-list">
        <div className="benefits-item">
          <FaUsers className="benefit-icon" />
          <span>Exclusive Whales TG & Private Tools Access</span>
        </div>
        <div className="benefits-item">
          <FaGift className="benefit-icon" />
          <span>Generous 10-Week Airdrop: 250M PF Weekly</span>
        </div>
        <div className="benefits-item">
          <FaRocket className="benefit-icon" />
          <span>Early Access to ECA & Future Projects</span>
        </div>
        <div className="benefits-item">
          <FaEthereum className="benefit-icon" />
          <span>0.05 ETH Worth of New Token Airdrops</span>
        </div>
        <div className="benefits-item">
          <FaLock className="benefit-icon" />
          <span>Complete Access to Firm Ecosystem Tools</span>
        </div>
      </div>
    ),
    tokenId: 1,
    imageUrl: "https://nft-cdn.alchemy.com/eth-mainnet/8369efecfbe3a479fb183f4e43a405ae",
    videoUrl: "https://raw.seadn.io/files/7b94410924d1bd9fc737c865b41140f1.mp4",
    tier: "Golden",
    price: "5000000000", // 5 billion
    icon: <FaGem className="tier-icon gold" />
  },
  {
    id: 2,
    name: "FIRM SILVER NFT",
    description: (
      <div className="benefits-list">
        <div className="benefits-item">
          <FaUsers className="benefit-icon" />
          <span>Exclusive Whales TG & Private Tools Access</span>
        </div>
        <div className="benefits-item">
          <FaGift className="benefit-icon" />
          <span>Standard 10-Week Airdrop: 100M PF Weekly</span>
        </div>
        <div className="benefits-item">
          <FaRocket className="benefit-icon" />
          <span>Early Access to ECA & Future Projects</span>
        </div>
        <div className="benefits-item">
          <FaEthereum className="benefit-icon" />
          <span>0.02 ETH Worth of New Token Airdrops</span>
        </div>
        <div className="benefits-item">
          <FaLock className="benefit-icon" />
          <span>Access to Core Firm AI Tools</span>
        </div>
      </div>
    ),
    tokenId: 2,
    imageUrl: "https://nft-cdn.alchemy.com/eth-mainnet/dbb400301378e8cf9c4d84ac1e412266",
    videoUrl: "https://raw.seadn.io/files/7a189c80ca8b9389e5466ce9020e2845.mp4",
    tier: "Silver",
    price: "2000000000", // 2 billion
    icon: <FaMedal className="tier-icon silver" />
  }
];

const NFTMint = () => {
  const [loadingStates, setLoadingStates] = useState({});
  const [error, setError] = useState('');
  const [selectedNFT, setSelectedNFT] = useState(0);
  const [account, setAccount] = useState(null);
  const [supplyInfo, setSupplyInfo] = useState({});
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [videoLoadErrors, setVideoLoadErrors] = useState({});

  const checkConnection = useCallback(async () => {
    const provider = window.ethereum || window.trustwallet;
    if (provider) {
      try {
        const accounts = await provider.request({ method: 'eth_accounts' });
        if (accounts.length > 0) {
          setAccount(accounts[0]);
        }
      } catch (error) {
        console.error('Error checking connection:', error);
      }
    }
  }, []);

  useEffect(() => {
    checkConnection();
    
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', (accounts) => {
        if (accounts.length > 0) {
          setAccount(accounts[0]);
        } else {
          setAccount(null);
        }
      });
    }

    return () => {
      if (window.ethereum) {
        window.ethereum.removeListener('accountsChanged', checkConnection);
      }
    };
  }, [checkConnection]);

  const fetchNFTData = useCallback(async () => {
    try {
      if (!window.ethereum) return;
      
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const contract = new ethers.Contract(NFT_ADDRESS, NFT_ABI, provider);
      
      const tokenId = selectedNFT;
      
      const activeConditionId = await contract.getActiveClaimConditionId(tokenId);
      const claimCondition = await contract.getClaimConditionById(tokenId, activeConditionId);
      
      const supply = await contract.totalSupply(tokenId);
      const maxSupply = await contract.maxTotalSupply(tokenId);
      
      setSupplyInfo({
        totalSupply: Number(supply),
        maxSupply: Number(maxSupply),
        priceInEth: ethers.utils.formatUnits(claimCondition.pricePerToken, 18)
      });
      
    } catch (err) {
      console.error('Error fetching NFT data:', err);
      setError('Failed to load NFT data');
    }
  }, [selectedNFT]);

  useEffect(() => {
    if (account) {
      fetchNFTData();
    }
  }, [account, fetchNFTData]);

  const connectWallet = async () => {
    // First check if we're on mobile
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    // Check if we're inside a dapp browser
    const isDappBrowser = window.ethereum || window.trustwallet;
    
    // If on mobile but not in a dapp browser, show the wallet selection modal
    if (isMobile && !isDappBrowser) {
      setShowWalletModal(true);
      return;
    }
    
    // If we have a provider (either desktop MetaMask or mobile dapp browser)
    if (isDappBrowser) {
      try {
        setError('');
        const provider = window.ethereum || window.trustwallet;
        const accounts = await provider.request({ method: 'eth_requestAccounts' });
        if (accounts.length > 0) {
          setAccount(accounts[0]);
          
          // Set up event listeners for account changes
          provider.on('accountsChanged', (newAccounts) => {
            if (newAccounts.length > 0) {
              setAccount(newAccounts[0]);
            } else {
              setAccount(null);
            }
          });
          
          // Set up event listeners for chain changes
          provider.on('chainChanged', () => {
            window.location.reload();
          });
        }
      } catch (err) {
        console.error('Error connecting wallet:', err);
        if (err.code === 4001) {
          setError('Please connect your wallet to continue');
        } else {
          setError('Failed to connect wallet: ' + (err.message || 'Unknown error'));
        }
      }
    } else {
      // On desktop without MetaMask
      setError('Please install MetaMask or Trust Wallet to mint NFTs');
      window.open('https://metamask.io/download/', '_blank');
    }
  };

  const openWalletApp = (walletType) => {
    // Get the current URL without any query parameters
    const currentUrl = window.location.origin + window.location.pathname;
    
    // Create the deep links
    if (walletType === 'metamask') {
      // MetaMask mobile deep link format
      window.location.href = 'https://metamask.app.link/dapp/' + currentUrl.replace('https://', '').replace('http://', '');
    } else {
      // Trust Wallet mobile deep link format
      window.location.href = 'https://link.trustwallet.com/open_url?coin_id=60&url=' + encodeURIComponent(currentUrl);
    }
    setShowWalletModal(false);
  };

  const mintNFT = async (nft, e) => {
    e.stopPropagation();
    if (!window.ethereum) {
      setError('Please install MetaMask to mint NFTs');
      return;
    }

    if (!account) {
      setError('Please connect your wallet first');
      return;
    }

    setLoadingStates(prev => ({ ...prev, [nft.id]: true }));
    setError('');

    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = await provider.getSigner();
      
      // First, we need to approve the NFT contract to spend our tokens
      const tokenContract = new ethers.Contract(FIRM_TOKEN_ADDRESS, FIRM_TOKEN_ABI, signer);
      const nftContract = new ethers.Contract(NFT_ADDRESS, NFT_ABI, signer);
      
      // Check allowance first
      const allowance = await tokenContract.allowance(account, NFT_ADDRESS);
      const price = ethers.utils.parseUnits(nft.price.toString(), 'ether');
      
      if (allowance < price) {
        console.log('Approving tokens...');
        try {
          const approveTx = await tokenContract.approve(NFT_ADDRESS, price);
          await approveTx.wait();
        } catch (approveError) {
          if (approveError.code === 4001 || approveError.code === 'ACTION_REJECTED' || 
              (approveError.info?.error?.code === 4001) || 
              approveError.message?.includes('user rejected') || 
              approveError.message?.includes('User denied')) {
            setError('Token approval cancelled - Please try again when ready');
            return;
          }
          throw approveError;
        }
      }

      // Now mint the NFT
      const allowlistProof = {
        proof: [],
        quantityLimitPerWallet: 0,
        pricePerToken: price,
        currency: FIRM_TOKEN_ADDRESS
      };

      try {
        const tx = await nftContract.claim(
          account,
          nft.tokenId,
          1,
          FIRM_TOKEN_ADDRESS,
          price,
          allowlistProof,
          "0x"
        );
        
        await tx.wait();
        alert(`Successfully minted ${nft.name}!`);
      } catch (mintError) {
        if (mintError.code === 4001 || mintError.code === 'ACTION_REJECTED' || 
            (mintError.info?.error?.code === 4001) || 
            mintError.message?.includes('user rejected') || 
            mintError.message?.includes('User denied')) {
          setError('Minting cancelled - Please try again when ready');
          return;
        }
        throw mintError;
      }
      
    } catch (err) {
      console.error('Minting error:', err);
      if (err.code === 4001 || err.code === 'ACTION_REJECTED' || 
          (err.info?.error?.code === 4001) || 
          err.message?.includes('user rejected') || 
          err.message?.includes('User denied')) {
        setError('Transaction cancelled - Please try again when ready');
      } else if (err.message?.includes('insufficient')) {
        setError('Insufficient FIRM tokens to complete the transaction');
      } else {
        setError('Something went wrong with the transaction. Please try again.');
      }
    } finally {
      setLoadingStates(prev => ({ ...prev, [nft.id]: false }));
    }
  };

  const formatAddress = (address) => {
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  const disconnectWallet = () => {
    setAccount(null);
    // Remove event listeners
    const provider = window.ethereum || window.trustwallet;
    if (provider) {
      provider.removeListener('accountsChanged', () => {});
      provider.removeListener('chainChanged', () => {});
    }
  };

  // Update video playback effect
  useEffect(() => {
    let mounted = true;

    const playVideo = async (video) => {
      if (!mounted) return;
      
      try {
        if (video.paused) {
          video.muted = true;
          video.playsInline = true;
          video.loop = true;
          await video.play();
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Video playback error:', error);
        }
      }
    };

    // Set up intersection observer to play videos when they become visible
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          playVideo(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    // Observe all videos
    document.querySelectorAll('.nft-video').forEach(video => {
      observer.observe(video);
    });

    return () => {
      mounted = false;
      observer.disconnect();
      document.querySelectorAll('.nft-video').forEach(video => {
        video.pause();
      });
    };
  }, []);

  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="nft-page">
        <div className="nft-mint-container">
          <div className="wallet-status">
            {account ? (
              <div className="wallet-connected">
                <div className="wallet-info">
                  <span className="wallet-dot"></span>
                  <span className="wallet-address">{formatAddress(account)}</span>
                </div>
                <button onClick={disconnectWallet} className="disconnect-button">
                  Disconnect
                </button>
              </div>
            ) : (
              <button onClick={connectWallet} className="connect-button">
                Connect Wallet
              </button>
            )}
          </div>

          <h2 className="nft-title">The Firm NFT Collection</h2>
          <p className="nft-subtitle">Mint your exclusive access pass to advanced features</p>

          <div className="nft-grid">
            {NFT_TYPES.map((nft) => (
              <div 
                key={nft.id}
                className={`nft-card ${selectedNFT === nft.id ? 'selected' : ''}`}
                onClick={() => setSelectedNFT(nft.id)}
              >
                <div className="nft-media">
                  {videoLoadErrors[nft.id] ? (
                    <img 
                      src={nft.imageUrl}
                      alt={nft.name}
                      className="nft-image"
                      loading="lazy"
                    />
                  ) : (
                    <video 
                      key={`video-${nft.id}`}
                      className="nft-video"
                      poster={nft.imageUrl}
                      muted
                      playsInline
                      loop
                      autoPlay
                      onError={(e) => {
                        console.error(`Error loading video for ${nft.name}:`, e);
                        setVideoLoadErrors(prev => ({ ...prev, [nft.id]: true }));
                      }}
                      style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                    >
                      <source src={nft.videoUrl} type="video/mp4" />
                      <img 
                        src={nft.imageUrl}
                        alt={nft.name}
                        className="nft-image"
                        loading="lazy"
                      />
                    </video>
                  )}
                </div>
                <div className="nft-info">
                  <div className="nft-header">
                    {nft.icon}
                    <h3>{nft.name}</h3>
                  </div>
                  <p>{nft.description}</p>
                  <div className="nft-tier">{nft.tier} Tier</div>
                  <div className="nft-price">
                    <SiFireship className="token-icon" /> {parseInt(nft.price).toLocaleString()} FIRM
                  </div>
                  {supplyInfo[nft.id] && (
                    <div className="nft-supply">
                      <span className="supply-label">Minted:</span>
                      <span className="supply-numbers">
                        {supplyInfo[nft.id].totalSupply} / {supplyInfo[nft.id].maxSupply}
                      </span>
                    </div>
                  )}
                  <button 
                    className={`mint-button ${nft.tier.toLowerCase()}`}
                    onClick={(e) => mintNFT(nft, e)}
                    disabled={loadingStates[nft.id] || !account}
                  >
                    {loadingStates[nft.id] ? (
                      <>
                        <FaSpinner className="spinner" />
                        Minting...
                      </>
                    ) : (
                      'Mint Now'
                    )}
                  </button>
                </div>
              </div>
            ))}
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          {showWalletModal && (
            <div className="wallet-modal">
              <div className="wallet-modal-content">
                <h3>Choose Your Wallet</h3>
                <div className="wallet-options">
                  <button 
                    className="wallet-option metamask"
                    onClick={() => openWalletApp('metamask')}
                  >
                    MetaMask
                  </button>
                  <button 
                    className="wallet-option trustwallet"
                    onClick={() => openWalletApp('trustwallet')}
                  >
                    Trust Wallet
                  </button>
                </div>
                <button 
                  className="close-modal"
                  onClick={() => setShowWalletModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NFTMint; 